import { ALGOS_E } from "@constants/Algos";
import { useState, useEffect, MouseEvent } from "react";
import { IHashSelectorProps } from "./HashSelector.props";

interface IPoolSelectorControl {
  readonly open: boolean;
  readonly value: ALGOS_E;

  onOpen(): void;
  onSelect(hash?: ALGOS_E): void;
  onClearValue(e: MouseEvent<HTMLSpanElement>): void;
}

export const useHashSelectorControl = (
  props: IHashSelectorProps
): IPoolSelectorControl => {
  const { hashOptions, initial, onChangeValue, onClearClick, onGetValue } =
    props;
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue_] = useState<ALGOS_E>(initial || hashOptions[0]);
  const onOpen = () => setOpen((prev) => !prev);

  const setValue = (v: ALGOS_E) => {
    setValue_((was) => {
      was !== v && onChangeValue && onChangeValue();
      return v;
    });

    onGetValue && onGetValue(v);
  };

  const onClearValue = (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (onClearClick) {
      onClearClick();
      return;
    }
    setValue(ALGOS_E.ALL);
  };

  useEffect(() => {
    if (initial) {
      setValue(initial);
    } else {
      setValue(hashOptions[0]);
    }
  }, [initial]);

  const onSelect = (hash?: ALGOS_E) => {
    if (!hash) {
      setOpen(false);
      setValue(ALGOS_E.ALL);
      return;
    }
    // const find = hashOptions.find((item) => item.id === id);
    setOpen(false);
    // if (!find) return console.error("Cannot find a setting");
    setValue(hash);
  };

  useEffect(() => {
    if (!open) return;

    const clear = () => {
      setOpen(false);
    };
    const exitEvent = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.body.addEventListener("click", clear);
    document.body.addEventListener("keydown", exitEvent);

    return () => {
      document.body.removeEventListener("click", clear);
      document.body.removeEventListener("keydown", exitEvent);
    };
  }, [open]);
  return {
    open,
    value,

    onOpen,
    onSelect,
    onClearValue,
  };
};
